import React, { Component, Fragment } from "react";
import SwitchButton from "../../../../UI/SwitchButton";

export default class Switcher extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { colunas } = this.props;
        return (
            <Fragment>

                <form onChange={this.props.onChange}>
                    <div className="row">
                        {Object.keys(colunas || {}).map((coluna, i) => {
                            return(
                                // <div className="form-check form-switch col-3">
                                //     <input className="form-check-input" type="checkbox" role="switch" id={`${coluna}`} defaultChecked={colunas[coluna]} />
                                //     <label className="form-check-label" htmlFor={`${coluna}`}>{coluna}</label>
                                // </div>
                                <div className="form-check form-switch col-3">
                                    <SwitchButton coluna={coluna} colunas={colunas} />
                                </div>
                            )
                        })}
                    </div>
                </form>

            </Fragment>
        )
    }
}